// extracted by mini-css-extract-plugin
export var planningContainer = "planning-module--planningContainer--iSFQB";
export var section = "planning-module--section--MC6PP";
export var icon = "planning-module--icon--fjEcm";
export var buttonColumn = "planning-module--buttonColumn--aQY+i";
export var link = "planning-module--link--jDVXd";